var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navigator"},[_c('img',{staticClass:"back-icon",attrs:{"src":_vm.lightBg ? _vm.icon['back-1'] : _vm.icon['back']},on:{"click":function($event){return _vm.$router.back()}}}),_c('p',{staticClass:"title",class:{ 'title-1': _vm.lightBg }},[_vm._v(" "+_vm._s(_vm.$route.name)+" ")]),_c('i',{staticClass:"holder"})])
}
var staticRenderFns = []

export { render, staticRenderFns }